import { Component } from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'

import { colors } from '@lmc/common/constants'
import { FamilyInviteWizard } from '../../../generic'
import { Button } from '@lmc/ui-kit'

interface FamilyPortalCompleteProps {
  fields?: any
  close: () => void
  preferredTerm: string
}

export default class FamilyPortalComplete extends Component<FamilyPortalCompleteProps> {
  form = null

  setFormRef = (node: null) => (this.form = node)

  componentDidMount() {
    // @ts-ignore
    if (this.form) return this.form?.scrollIntoView()
  }

  // Initial step section
  InfoSection(props: {
    imgUrl: any
    title: any
    subtitle: any
    children: any
  }) {
    const { imgUrl, title, subtitle, children } = props

    return (
      <div className={css(classes.infoSection)}>
        <div className={css(classes.stakeHolderContainer)}>
          <img alt="" src={imgUrl} />
          {title}
          <div className={css(classes.underLine)} />
        </div>
        <div className={css(classes.plainText)}>{subtitle}</div>
        {children}
      </div>
    )
  }

  renderLinkContainer = (preferredTerm: string, slicedTerm: string) => (
    <div className={css(classes.linkContainer)}>
      {/*
       // @ts-ignore */}
      <this.InfoSection
        imgUrl="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/Social.png"
        title={preferredTerm}
        subtitle={CLIENT_TEXT(slicedTerm)}
      />
      <this.InfoSection
        imgUrl="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/Activies+and+Social.png"
        title="Families"
        subtitle={FAMILY_TEXT}
      >
        <a
          className={css(classes.links)}
          href="https://support.logmycare.co.uk/en/articles/4583018-announcement-email-template-for-families"
          target="_blank"
          rel="noreferrer"
        >
          {'Email template >'}
        </a>
      </this.InfoSection>
      {/*
       // @ts-ignore */}
      <this.InfoSection
        imgUrl="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/Family+Update.png"
        title="Carers"
        subtitle={CARER_TEXT}
      />
    </div>
  )

  renderInitialStepContainer = (slicedTerm: string) => {
    const { preferredTerm } = this.props
    return (
      <div className={css(classes.initialStepContainer)}>
        <h5 className={css(classes.textBold)}>Step 1</h5>
        <h4 className={css(classes.textPrimary)}>Let everyone know</h4>
        {this.renderLinkContainer(preferredTerm, slicedTerm)}
      </div>
    )
  }

  renderSecondStepContainer = (
    close: (() => void) | undefined,
    slicedTerm: string
  ) => (
    <div className={css(classes.secondStepContainer)}>
      <h5 className={css(classes.textBold)}>Step 2</h5>
      <h4 className={css(classes.textPrimary)}>Invite family members</h4>
      <div className={css(classes.subHeadingContainer)}>
        <div className={css(classes.subHeading)}>
          {FAMILY_INTEREST(slicedTerm)}
        </div>
        <br />
        <Button onClick={close} style={{ marginLeft: 15 }} variant="default">
          <div className={css(classes.skipButton)}>
            <img
              alt=""
              src="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/Skip.svg"
              style={{ marginRight: 5 }}
            />
            Skip for now
          </div>
        </Button>
      </div>
      <FamilyInviteWizard />
    </div>
  )

  render() {
    const { preferredTerm, close } = this.props

    // Residents -> resident
    const slicedTerm = preferredTerm.slice(0, -1).toLowerCase()

    // TODO: Add a tag links
    return (
      <div className={css(classes.container)}>
        <div style={{ height: 80 }} ref={this.setFormRef} />
        <div className={css(classes.heading)}>{SETUP_COMPLETE}</div>
        <div className={css(classes.subHeading)}>{MODULE_SETUP}</div>
        {this.renderInitialStepContainer(slicedTerm)}
        {this.renderSecondStepContainer(close, slicedTerm)}
        <Button onClick={close} variant="default">
          Back to Family App Settings
        </Button>
      </div>
    )
  }
}

const SETUP_COMPLETE = 'Family App Setup Complete!'
const MODULE_SETUP =
  'Amazing! Your Family App is all set up! Now you can start inviting families to the app.'
const CLIENT_TEXT = (preferredTerm: string) =>
  `Make sure you ask if your ${preferredTerm}s are happy to share their information with family members.`
const FAMILY_TEXT =
  'Let families know about the new family app that is available for them.'
const CARER_TEXT =
  'Important to know that families will be able to access certain logs in real time.'
const FAMILY_INTEREST = (preferredTerm: string) =>
  `Once you know a ${preferredTerm} is happy to share their information and a family member is interested in the App, you can start inviting them straight away.`

const classes = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '90vw',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  heading: {
    color: colors.black,
    fontSize: 28,
    fontWeight: 300,
    marginBottom: 20
  },
  infoSection: {
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '33%'
  },
  initialStepContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 30,
    width: '50%'
  },
  linkContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  links: {
    paddingTop: 5
  },
  plainText: {
    fontSize: 12,
    textAlign: 'center'
  },
  residentSectioncontainer: {
    marginTop: 50,
    marginBottom: 50,
    display: 'block'
  },
  searchBoxParentContainer: {
    width: '100%',
    marginBottom: 10
  },
  searchInput: {
    fontSize: 16
  },
  secondStepContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 30,
    width: '70%'
  },
  skipButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 2
  },
  stakeHolderContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 5,
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 5
  },
  subHeading: {
    color: colors.black,
    fontWeight: 400,
    fontSize: 12
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 30
  },
  textBold: {
    fontWeight: 700,
    fontSize: 14
  },
  textPrimary: {
    fontWeight: 400,
    fontSize: 16,
    color: colors.pink
  },
  underLine: {
    backgroundColor: colors.black,
    height: 1,
    width: '100%'
  }
})
